const zh = {
  easyCareer: "轻松职业生涯",
  adminSystemAdmin: "管理员系统管理者",
  memberLogin: "会员登录",
  emil: "电子邮件地址",
  password: "密码",
  forgotPassword: "忘记密码",
  verificationCode: "验证码",
  login: "登录",
  tipsEmail: "请输入邮箱地址",
  tipsPaw: "请输入密码。",
  tipsCode: "请输入验证码。",
  errorCode: "用户验证码错误",
  errorPw: "密码校验失败",
  changeMechanism: "请选择机构类型",

  errorMsg: "输入格式错误！",
  userMsg: "用户已认证",
  registration: "注册",
  clickHere: "点击此处进行",
  passwordReissue: "重新设置密码",
  passwordReissueTitle:
    "请输入您注册的电子邮件地址，此页面会发送电子邮件到您的邮箱，请前往查看。",
  send: "发送邮件",
  pleaseEmil: "请输入正确的电子邮件地址",
  emilError: "电子邮件格式不正确",
  specializedCare: "长期护理人员专门监护",
  hiringForeigners: "有雇佣外国人的经验",
  conciseSystem: "系统简洁，使用方便",
  lookWait: "寻找它，而不是等待！",
  newRegistration: "新会员注册",
  name: "姓名",
  namejop: "新增姓名",
  passwordRules: "6-18位数字，必须包含数字和英文",
  confirmPassword: "确认密码",
  twoPassword: "两个密码的内容不同",
  newPaw: "请填写密码",
  newEmail: "请填写邮件",
  userNameRules: "请输入 4 到 32 位的用户名",
  yourRole: "您的角色",
  bedNumber: "床位数",
  medicalInstitution: "医疗机构",
  //医療機関 医療機関名
  educationalInstitution: "教育机构",
  // 教育機関 教育機関名
  useRules: "使用规则",
  agreeToUse: "我已阅读并且同意使用",
  toRegister: "注册",
  alreadyRegistered: "已经注册的用户",
  clickHereGoTo: "请点击这里",
  homepost: "管理页面",
  jobPosting: "招聘启事",
  jobApplyView: "查看该案件应聘信息",
  signUp: "注册",
  largestStaffing: "轻松就职",
  searchForAll: "在这里搜索医疗机构、教育机构、职位列表、人力资源等",
  search: "搜索",
  jobSquare: "工作广场",
  talentPool: "人才库",
  jobOffer: "工作机会",
  institutionalInformation: "机构信息",
  ifRegisteredEnterName: "如果已注册，请输入机构名称",
  institutionName: "机构名称",
  forNewEnterContents: "如需新注册，请从此处输入内容",
  postCode: "邮政编码",
  //郵便番号
  enterZipCode: "输入您的邮政编码",
  location: "所在地",
  //所在地
  enterAddress: "请输入您的地址",
  institutionalAttributes: "机关属性",
  //機関属性
  clinic: "诊所",
  generalHospital: "综合医院",
  communityMedicalHospital: "社区医疗支援医院",
  specialFunctionHospital: "特殊功能医院",
  paidNursingHome: "有偿疗养院",
  housingElderly: "老年人住房",
  groupHome: "团体之家",
  careHouse: "护理院",
  specialElderlyNursing: "特殊养老院",
  longTermCare: "长期护理保健设施",
  longTermFacility: "看护型医疗设施",
  homepageEtc: "主页、Youtube、Facebook、Twitter 等",
  representativeName: "代表姓名",
  //代表者
  enterRepresentative: "输入代表姓名",
  institutionalNumber: "机构电话号码",
  EnterPhoneNumber: "输入你的电话号码",
  registeredCapital: "注册资本",
  oneMillionYen: "0～100万日元",
  baiMillionYen: "101～500万日元",
  fiveHundredMillionYen: "501～5000万日元",
  FiveThousandMillionYen: "51万日元～1亿日元",
  hundredMillion: "1亿日元～5亿日元",
  twoBillion: "20亿日元以上",
  noBed: "无床",
  institutionalInformationMain: "机构信息",
  signUpButton: "注册",
  LogImage: "上传图片",
  numberStaff: "职员数",
  //授業員数 職員数
  numberOfEmployees: "在职员工人数",
  //工作人数
  numberOfBets: "投注数",
  institutionNumber: "机构编号",
  staffApplication: "员工申请",
  managerApplication: "管理员申請",
  businessContent: "业务内容",
  toEdit: "编辑",
  certified: "认证",
  register: "登记",
  collection: "收藏",
  chatHistory: "聊天记录",
  pleaseEnterMessage: "请输入留言信息",
  decideIfWantEmployee: "确定是否进行员工申请",
  confirm: "确定",
  newInstitution: "新建机构",
  staffManagement: "员工管理",
  GiveAdministrator: "给予管理员",
  //给予管理员权限
  edit: "编辑",
  delete: "删除",
  institutionalRegistrationFailed: "机构注册审查未通过。",
  pleaseApplyResettingAgain: "请重新申请重置。",
  editAgain: "再次编辑",
  institutionalRegistrationCompleted: "机构注册审查已完成。",
  close: "关闭",
  reviewingInstitutionalRegistration: "我们正在审查机构注册。",
  chooseRecommender: "选择推荐人",
  projectTitle: "项目名称",
  occupationCategory: "职业类别",
  workLocation: "工作地点",
  // 勤務地
  employmentForm: "雇用形态",
  employmentForm2: "雇用形态2",
  employmentForm3: "雇用形态3",
  employmentForm4: "雇用形态4",
  //雇佣形态1
  dutyTime: "勤务时间",
  // 勤務時間
  salary: "薪水",
  numberOfHires: "雇用人数",
  // 採用人数
  recruiter: "招聘人员",
  targetRecruitmentTime: "目标招聘时间",
  // 目標採用時期
  workContent: "工作内容",
  // 勤務内容
  welfare: "福利",
  // 福利厚生
  employmentConditions: "就业条件",
  // 採用条件
  other: "其他",
  humanResourcesPosting: "人力资源张贴",
  photograph: "照片",
  // 写真
  Fur: "名",
  //フリガナ
  employmentCharge: "就职担当",
  familyName: "姓",
  sex: "性别",
  //性別
  telephoneNumber: "电话号码",
  //電話番号
  email: "电子邮件",
  currentAddress: "目前地址",
  //現住所
  japanese: "日语",
  english: "英语",
  qualification1: "资格1",
  qualification2: "资格2",
  qualification3: "资格3",
  selfPR: "自我介绍",
  temporarilySaved: "暂时保存",
  next: "下一个",
  goodAtJapanese: "擅长日语",
  qualified: "合格的",
  interviewAtAnytime: "随时面试",
  determined: "决定",
  postingJobOffer: "发布工作机会",
  projectTitleName: "项目名称",
  projectPhoto: "项目照片",
  oneSheet: "＋ 第一张",
  twoSheet: "＋ 第二张",
  threeSheet: "＋ 第三张",
  foreignersWelcome: "欢迎外国人",
  inexperiencedOK: "没经验 OK",
  newGraduateOK: "应届毕业生 OK",
  educationalBackgroundMatter: "教育背景",
  salaryConditions: "工资・条件",
  return: "返回",
  fullTimeEmployee: "全职员工",
  partTimeJob: "兼职工作",
  specificSkill: "具体技能",
  technicalInternTrainee: "技术实习生",
  resume: "恢复",
  careerRequest: "职业・请求",
  dateAdmission: "入学日期",
  graduationDate: "毕业日期",
  school: "学校",
  major: "专业",
  startYear: "开始年月",
  endDate: "结束日期",
  workPlace: "工作地点",
  belongs: "所属机关",
  belongsMedical: "所属医疗机关",
  preferredWorkplace: "首选工作场所",
  desiredHireTime: "希望租用时间",
  desiredOccupationCategory: "期望的职业类别",
  expectedSalary: "期望薪水",
  otherWishes: "其他希望",
  basicInformation: "基本信息",
  apply: "申请",
  allCandidates: "所有应聘者",
  favoriteTalent: "人才收藏",
  favoriteMedical: "最喜欢的医疗机构",
  validatingRegistrationCode: "正在验证注册码",
  resetPassword: "重置密码",
  newPassword: "新密码",
  enterPasswordAgain: "确认新密码",
  newAdminRegistration: "平台管理员新增",
  avatarAddress: "头像地址",
  certificationStatus: "认证状态",
  status: "状态",
  newAdminAdd: "添加",
  //状態
  userName: "用户名",
  userID: "用户ID",
  //ユーザーID
  addInfo: "新增信息",
  popupPrompts: "请您输入用户id和用户密码",
  talentManagement: "人才管理",
  new: "＋新增",
  changeState: "状态更改",
  peopleView: "人员查看",
  selected: "已选择",
  notSelected: "未选择",
  unpublished: "未发布",
  inTheReview: "审核中",
  nowPublished: "已发布",
  disabled: "已禁用",
  completed: "已完成",
  published: "公开中",
  stopUsing: "停用",
  viewJobInformation: "查看应聘信息",
  goToDetailPage: "进入详细页面",
  talk: "进行交谈",
  manyAchievements: "许多成就",
  programmingPossible: "可转接",
  japaneseWindow: "日本窗口",
  japaneseVs: "日本语",
  caseName: "案件名",
  //応募案件
  educationId: "教育机关编号",
  medicId: "医疗机关编号",
  // 医療機関番号
  inauguration: "就职担当",
  //就職担当 担当者
  talentNumber: "人材番号",
  caseNumber: "案件番号",
  fundingDayPayment: "申请日期",
  bookTestResults: "书类选考审核",
  date: "日期",
  faceAttending: "面接参加",
  medicalContractPreparation: "医疗契约准备",
  medicalResidencyEligibility: "医疗再留资格办理",
  medicalEntry: "医疗入境办理",
  medicalEnrollmentsSuccess: "医疗入社（成功）",
  MedicalEnrollmentSuccessTime: "医疗入社（成功）时间",
  educationBookSelectionExamination: "教育书类选考审核",
  educationalInterviewReview: "教育面试审核",
  educationalEntry: "医疗入境办理",
  educationalCompactPreparation: "教育契约准备",
  educationallmentsSuccess: "教育入社（成功）",
  educationalResidencyEligibility: "教育再留资格办理",
  operate: "操作",
  Completion: "创建时间",
  typeOfWork: "工作类别",
  give: "给予",
  minimum: "最低工资",
  // 最低額
  maximumAmount: "最高工资",
  // 最高額
  applyForDailyPayment: "申请日期",
  payonTheDay: "掲載日",
  numberOfVisits: "参观数",
  //観覧回数 阅览数 観覧数
  senderNumber: "发送人编号",
  senderName: "发送人名称",
  recipientNumber: "接收人编号",
  trusteeName: "接收人名称",
  deliveryTime: "发送时间",
  deliveryTimein: "开始日期",
  deliveryTimeout: "结束日期",
  chatSource: "聊天来源",
  chatContent: "聊天内容",
  memberMumber: "人员编号",
  jobView:"个人简历",
  //チャット内容
  limit: "权限",
  //权限
  numberOfCases: "担当案件数",
  //担当数
  userModification: "用户修改",
  mailSentSuccessfully: "邮件发送成功",
  emailSendingFailed: "邮件发送失败",
  NewStaff: "新工作人员",
  id: "id",
  已收藏请勿重复操作: "已收藏请勿重复操作",
  //番号
  registerDay: "注册日期",
  //登録日付
  registerDayselsect: "选择日期",
  lastUpdataDay: "最新修正时间",
  //最新修正日付
  lastLogin: "最新登录",
  //最新ログイン
  studentNumber: "学生数",
  //学生人数
  workerNumner: "机构工作人员",
  //機関スタッフ
  jobCaseNumber: "求人案件数",
  idCreater: "ID创设者",
  hopeToHireForm1: "希望雇佣形式1",
  hopeToHireForm2: "希望雇佣形式2",
  hopeToHireForm3: "希望雇佣形式3",
  hopeToHireForm4: "希望雇佣形式4",
  otherWant: "其他要求",
  studentName: "学生姓名",
  //学生氏名
  birth: "出生年月日",
  candidates: "应聘人",
  advance: "推進",
  recruitmentClassificationInformation: "招聘分类信息",
  companyName: "公司名",
  monthlyIncome: "月收入",
  seniorSchool: "専門学校",
  teacherNumber: "教师人数",
  postTheLastLoginTimeOfThePostLeader: "发布岗位负责人最后登陆时间",
  //新增
  viewingTimes: "观看次数",
  nursing: "护理",
  rehabilitation: "复原",
  hospital: "医院",
  projectApplicationDetails: "项目申请详情",
  collectApplicationCases: "收藏应聘案件",
  education: "学历",
  logout: "退出登录",
  successfulApplication: "应聘申请成功",
  failulApplication: "已存在重复应聘",
  //新增 :"",
  fullName: "全名",
  contactAddress: "联系地址",
  period: "时期",
  languageSkills: "语言能力",
  qualification: "资质",
  workHistory: "工作经历",
  affiliation: "联系",
  joinCompany: "加入公司",
  request: "要求",
  occupation: "职业",
  postingNewTalent: "+ 发布新人才`",
  male: "男",
  female: "女",
  newEducationUser: "新增教育机构员工",
  newMedicalUser: "新增医疗机构员工",
  reviseEducationUser: "修改教育机构员工",
  reviseMedicalUser: "修改医疗机构员工",
  noResults: "暂无查询结果",
  dataEmpty: "必填项不能为空！",
  registrationAgreement:
    "招聘单位、信息发布商（统称注册公司）和求职者，三方行为必须接受本协议条款的制约；若您不接受本协议的条款，请勿使用本网站，否则后果自负。该协议一经接受立即生效。\n" +
    "\n" +
    "1.信息的发布\n" +
    "\n" +
    "不得发布任何违反有关法律规定、社会道德的信息； 不得发布任何与本网站求职、招聘目的不相适的信息； 不得发布任何不完整、虚假的信息； 用户对所发布的信息的真实性、正确性及其产生的后果承担完全责任。\n" +
    "\n" +
    "2.信息的使用\n" +
    "\n" +
    "招聘单位仅可就本单位招聘目的使用求职者的简历信息，禁止使用本网站进行中介代招； 求职者仅可因应聘某职位，使用招聘单位发布的招聘信息； 本网站提供的其它信息，仅与其相应内容有关的目的而被使用；\n" +
    "\n" +
    "不得将任何本网站的信息用作任何商业目的。 任何用户不得通过打印、下载、拷贝或其他方式再造其他用户的可辨认的信息。未经特定用户同意的上述任何操作都被严格禁止。\n" +
    "\n" +
    "3.信息的公开\n" +
    "\n" +
    "在本网站所登录的任何信息，均有可能被任何本网站的访问者浏览，也可能被错误使用。本网站对此将不予承担任何责任。\n" +
    "\n" +
    "4.信息的准确性\n" +
    "\n" +
    "任 何在本网站发布的信息，均必须符合合法、准确、及时、完整、真实的原则。但本网站将不能保证所有由第三方提供的信息，或本网站自行采集的信息完全准确。使 用者了解，对这些信息的使用，需要经过进一步核实。本网站对访问者未经自行核实误用本网站信息造成的任何损失不予承担任何责任。\n" +
    "\n" +
    "5.信息更改与删除\n" +
    "\n" +
    "除了信息的发布者外，任何访问者不得更改或删除他人发布的任何信息。本网站有权根据其判断保留修改或删除任何不适信息之权利。\n" +
    "\n" +
    "6.版权、商标权\n" +
    "\n" +
    "本 网站的图形、图像、文字、声音、相片及其程序，广告中的全部内容、电子邮件的全部内容等，均属www.jobyp.com的版权，受商标法及相关知识产权法律保护。 未经www.jobyp.com书面许可，任何人不得下载、复制、再使用。在本网发布信息之商标，归其相应的商标所有权人，受商标法保护。\n" +
    "\n" +
    "7、注册信息使用\n" +
    "\n" +
    "注 册会员所提供的个人资料将会被www.jobyp.com统计、汇总，在我们的严格管理下，为www.jobyp.com的广告商及合作者提供依据。 为了提供更完善的服务，www.jobyp.com会不定期地通过注册会员留下的电子邮件同该会员保持联系。同时，我们会定期电子贺卡、资讯或电子杂志给注册会员。\n" +
    "\n" +
    "www.jobyp.com承诺：在未经访问者授权同意的情况下，www.jobyp.com不会将访问者的个人资料泄露给第三方。但以下情况除外。\n" +
    "\n" +
    "1) 根据执法单位之要求或为公共之目的向相关单位提供个人资料；\n" +
    "\n" +
    "2) 由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露；\n" +
    "\n" +
    "3) 由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等；\n" +
    "\n" +
    "4) 由于与www.jobyp.com链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果；\n" +
    "\n" +
    "5) 为免除访问者在生命、身体或财产方面之急迫危险。\n" +
    "\n" +
    "8.自责\n" +
    "\n" +
    "所有使用本网站的用户，对使用本网站信息和在本网站发布信息的被使用，承担完全责任。 用户必须同意独自承担由于登录www.jobyp.com或通过www.jobyp.com登录到其他站点而形成的全部风险。\n" +
    "\n" +
    "所有用户独立承担与他人交流信息及发送应聘/招聘意向所造成的后果。本公司不担保用户发送给另一方用户的资料的真实性、精确性与可靠性。用户对所接受的资料的信任纯属个人风险。\n" +
    "\n" +
    "www.jobyp.com一经发现任何有违反本协议或侵犯法律的行为，有权马上解除该用户的会员资格及禁止其再次登录本网站。 www.jobyp.com保留删除一切非法的、辱骂性的及不健康的资料的权力。\n" +
    "\n" +
    "9.服务终止\n" +
    "\n" +
    "本网站有权在预先通知或不予通知的情况下终止任何免费服务。\n" +
    "\n" +
    "10.争议处理\n" +
    "\n" +
    "本网站因正常的系统维护、系统升级，或者因网络拥塞而导致网站不能访问，本网站不承担任何责任。\n" +
    "\n" +
    "本协议服从中华人民共和国法律解释；用户与www.jobyp.com双方都必须遵守中华人民共和国的司法管辖。如发生本协议相关条款与中华人民共和国法律相抵触时，则该条款将按相关法律重新解释，而其他条款则依旧保持对用户产生法律效力和影响。\n" +
    "\n" +
    "11.免责条款\n" +
    "\n" +
    "本 网并无随时监视此网址，但保留对其实施实时监视的权利。对于他方输入的，不是本网发布的材料，本网概不负任何法律责任。应聘信息发布方必须对其存入简历中 心的个人简历及材料的格式、内容的准确性和合法性独立承担一切法律责任。招聘信息的发布方对其在职位数据库公布的材料独立承担一切法律责任。 本网不保证对某一种职位描述会有一定数目的使用者来浏览，也不保证会有一位特定的使用者来浏览。对于其他网址链接在本网址的内容，本网概不负法律责任。",
  documentScreening: "文件筛选",
  interview: "面试",
  contract: "契约",
  statusOfResidence: "在留资格",
  travel: "旅行",
  joiningCompany: "加入公司",
  application: "应用",
  promotionStatus: "促销状态",
  contactHistory: "联系记录",
  citizen: "姓名",
  birthDay: "出生日期",
  applicationDate: "申请日期",
  situationId: "状态",
  applicantSide: "申请方",
  recruitmentSide: "招聘方",
  pass: "通过",
  ng: "NG",
  medicalInstitutionsHaveOperated: "医疗机构已操作,等待教育机构操作",
  WaitingEducational: "等待教育机构操作",
  noSure: "平台管理员审核不通过",
  WaitingMedicalInstitution: "等待医疗机构操作",
  waitingBothOperate: "等待双方操作",
  complete: "完成",
  EducationalOperatedMedicalInstitutionsOperate:
    "教育机构已操作，等待医疗机构操作",
  applicationCompleted: "应聘完成",
  educationalOperationCompleted: "教育机构操作完成",
  medicalOperationCompleted: "医疗机构操作完成",
  educationalNotOperating: "教育机构未操作",
  operationMedicalInstitutionFailed: "医疗机构操作不通过",
  educationalHavePassed: "教育机构操作已通过",
  educationalInstitutionsFailed: "教育机构未通过",
  medicalNotOperating: "医疗机构未操作",
  medicalHavePassed: "医疗机构已通过",
  adminReviewing:"管理员审查中",
  adminFailed:"管理员审核不通过",
  adminLogin: "管理员登录",
  effortlessCareer: "轻松职业生涯",
  choosingAnEducationalInstitution: "选择教育机关",
  successfullyDeleted: "删除成功",
  changeStatus: "状态变更成功",
  failedToDelete: "删除失败",
  reviewed: "已被审核",
  chooseRow: "请选择操作数据",
  pleaseSelectTheUserYouWantToDelete: "请选择想要删除的用户",
  loginFailed: "登录失败",
  successfullyModified: "修改成功",
  failToEdit: "修改失败",
  save: "保存",
  signOut: "退出登录",
  informationStatus: "信息状态",
  saveSuccess: "保存成功！",
  saveFail: "保存失败！",
  releaseSuccess: "添加成功！",
  releaseFail: "添加失败！",
  NumberMedicalInstitutions: "医疗机构数量",
  NumberEducationalInstitutions: "教育机构数量",
  applicationCaseNumber: "应用案例数量",
  NumberJobOffers: "工作机会数",
  NumberOfPersonnel: "人数",
  NoticeToInstitutions: "给机构的通知",
  serviceRequest: "服务请求",
  seeMore: "看更多",
  MattersProcessed: "待处理事项",
  applicationReview: "应聘审核",
  medicalInstitutionAudit: "医疗机构审核",
  recruitmentReview: "招聘审核",
  educationalInstitutionAudit: "教育机构审核",
  loadingWord: "正在加载",
  messageManagement: "消息管理",
  applicationManagement: "应聘管理",
  stateChange: "状态更改",
  medicalInstitutionManagement: "医疗机构管理",
  eduInstitutionManagement: "教育机构管理",
  informationNotModified: "信息并未修改",
  endOfRecruitment: "招聘结束",
  emailRegistered: "邮箱已被注册",
  dataDictionary: "数据字典",
  caseManagement: "案件管理",
  //后加
  selectEducationalAdministrator: "选择教育机关管理员",
  hpOrSns: "HP or SNS",
  selectMedicalAdministrator: "选择医疗机关管理员",
  collectionManagement: "收藏管理",
  chinese: "中文",
  applicationStatus: "应聘状态",
  promise: "承诺",
  rejection: "拒绝",
  uniquelyIdentifies: "唯一标识",
  dataName: "名称",
  creatorId: "创建人ID",
  creatorName: "创建人名称",
  creationTime: "创建时间",
  dateItemAdd: "+新建",
  content: "内容",
  remark: "备注",
  deleteState: "删除状态",
  keyValue: "键值",
  addDataDictionary: "新增数据字典",
  addDataItem: "新增数据项",
  capital: "资本金",
  yes: "yes",
  no: "no",
  userId: "用户身份",
  ip: "IP",
  selectMedical: "选择医疗机关",
  cancel: "取消",
  selectAvatar: "请选择头像,并上传",
  selectEducational: "选择教育机关",
  allApplications: "全部应聘案件",
  employeesNumber: "在职员工人数",
  businessIntroduction: "事业介绍",
  student: "在校生",
  removeFavorite: "从收藏夹中删除",
  imageSize: "上传头像图片大小不能超过 2MB!",
  selectImage: "请选择图片文件",
  selectMessage: "请至少选择一个信息",
  talent: "人力资源",
  inputEmailAddress: "请输入邮箱地址",
  enterPassword: "请输入密码",
  enterVerificationCode: "请输入验证码",
  OnlyOneMessageSelected: "只能选择一条信息",
  selectLeastOneMessage: "至少选择一条信息",
  enterAllInformation: "请输入全部信息",
  allName: "全部",
  inconsistentPasswordEnteredTwice: "两次密码输入不一致",
  addedSuccessfully: "新增成功",
  queryFailed: "查询失败",
  changeNameEmpty: "更改名字不可为空",
  nameChangedSuccessfully: "名称修改成功",
  nameChangeFailed: "名称修改失败",
  KeyModifiedSuccessfully: "键值修改成功",
  failedModifyKeyValue: "键值修改失败",
  failedModifyStatus: "修改数据项状态失败",
  activated: "已启用",
  hasStopped: "已停止",
  pleaseSelectUser: "请选择一名用户",
  AtMostOneUserSelected: "最多只能选择一名用户",
  theUserAlreadyExists: "该用户已存在",
  addFailed: "新增失败",
  successfulOperation: "操作成功",
  operationFailed: "操作失败",
  pleaseEnterPasswordAgain: "请再次输入密码",
  collectionSuccess: "收藏成功",
  submitABug: "提交错误",
  thisApplicationFavorite: "该应聘已被收藏",
  searchSuccessful: "查询成功",
  institutionDoesExistEmpty: "机构不存在或查询输入为空",
  bindingSucceeded: "绑定成功",

  //管理员新增机构输入提示
  warningEducationName: "教育机关名输入字数超过限制100位",
  warningEducationPost: "教育机关邮编输入字数超过限制20位",
  warningEducationLocal: "教育机关所在地输入字数超过限制255位",
  warningEducationSns: "教育机关网址输入字数超过限制255位",
  warningEducationRpName: "教育机关代表人名字输入字数超过限制100位",
  warningEducationPhone: "教育机关电话输入字数超过限制20位",
  warningMedicalName: "医疗机关名输入字数超过限制100位",
  warningMedicalPost: "医疗机关邮编输入字数超过限制20位",
  warningMedicalLocal: "医疗机关所在地输入字数超过限制255位",
  warningMedicalSns: "医疗机关网址输入字数超过限制255位",
  warningMedicalRpName: "医疗机关代表人名字输入字数超过限制100位",
  warningMedicalPhone: "医疗机关电话输入字数超过限制20位",
  //人才
  peopleDetail: "人才详情",
  waringAnonym: "请输入名或名输入字数超过限制50位",
  waringName: "请输入性或性输入字数超过限制50位",
  waringTelephone: "请输入电话号或电话号输入字数超过限制20位",
  waringEmail: "请输入邮箱或邮箱输入字数超过限制100位",
  waringAddress: "请输入地址或地址输入字数超过限制100位",
  waringOther: "其他输入字数超过限制100位",
  waringQualification1: "资格1输入字数超过限制100位",
  waringQualification2: "资格2输入字数超过限制100位",
  waringQualification3: "资格3输入字数超过限制100位",
  waringPr: "请输入自我介绍或自我介绍输入字数超过限制255位",
  waringSchool: "请选择学校",
  waringProfession: "请输入专业或专业输入字数超过限制100位",
  waringWorkPlace: "工作地点输入字数超过限制100位",
  upSuccess: "更新成功",
  waringType: "请选择机关",
  waringHopeWorkplace: "首选工作场所输入字数超过限制100位",
  waringStartSalary: "请输入起始工资或起始工资输入字数超过限制11位",
  waringEndSalary: "请输入结束工资或结束工资输入字数超过限制11位",
  waringOtherHope: "其他希望输入字数超过限制255位",
  //wzw
  inputWord1: "机构名称输入字数超过限制100位",
  inputWord2: "番号输入字数超过限制32位",
  inputWord3: "地址输入字数超过限制255位",
  inputWord4: "HP输入字数超过限制255位",
  inputWord5: "代表者姓名输入字数超过限制255位",
  inputWord6: "机构电话输入字数超过限制20位",
  inputWord7: "机构信息输入字数超过限制255位",
  inputwords:"请输入必选项",
  //新增
  sureAboutThisOperation: "是否确定此操作？",
  startUsing: "启用",
  Status: "状态",
  onlyNormalUsers: "只能操作正常用户",

  warningJobName: "案件名输入字数超过限制100位",
  warningJobRecruitNumber: "案件采用人数输入类型为数字且不超过20位",
  warningJobWorkSpace: "案件工作地点输入字数超过限制50位",
  warningJobWorkTime: "案件工作时间输入字数超过限制100位",
  warningJobWorkContent: "案件工作内容输入字数超过限制255位",
  warningJobSalary: "请输入案件薪资或案件薪资输入类型为数字且不超过20位",
  warningJobWelfareTreatment: "请输入案件福利或案件福利输入字数超过限制255位",
  warningJobEmploymentConditions: "案件采用条件输入字数超过限制255位",
  warningJobOther: "请输入案件其他信息或案件其他信息输入字数超过限制255位",
  noMoreData: "暂无更多",
  jobDetail: "案件详情",
  dataMiss: "有必填数据漏了",
  warn: "警告",
  question: "有问题",
  collectType: "收藏类型",
  id: "番号",
  collectId: "收藏番号",
  addNone: "该岗位绑定的数据不存在，请检查数据",
  addCheck: "新增失败，请检查岗位或人才是否存在，状态是否正常",
  addHave: "应聘已存在",
  institutionalPlaceholder: "请输入机构信息",
  userInstitutionalFailed:'机构绑定审核不通过，请重新绑定',
  userApplying:'机构正在处理绑定申请',
  warning:"警告",
  determine:"确定",
  warningText:"必选项未填写",
  authentication:"认证成功",
};
export default zh;



// WEBPACK FOOTER //
// ./src/locale/zh-CH.js